import axios from "axios";
import InternalUserAutocomplete from "../../shared/InternalUserAutocomplete";
import { InternalUser } from "../../types/app";
import { ClientOrder } from "../types/ClientOrder";
import { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";

export default function SalesPersonAutocomplete({
  clientOrder,
  update
}: {
  clientOrder: ClientOrder;
  update: (clientOrder: ClientOrder, salesReps: InternalUser[]) => void;
}) {
  const [originalSalesReps, setOriginalSalesReps] = useState<InternalUser[]>([]);

  const [loading, setLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<InternalUser[]>([]);
  const limit = 3;

  const handleSalesRepsChange = async () => {
    setLoading(true);
    const salesRepIds = users.map((u) => u.salesRepId);
    await axios.post("/proxy/api/orders/setsalesreps", {
      orderNumber: clientOrder.number,
      salesRepIds
    });
    update(clientOrder, users);
    setOriginalSalesReps(users);
    setLoading(false);
  };
  useEffect(() => {
    const parsedSalesReps =
      clientOrder?.salesReps?.split(", ").map((rep) => {
        const [fullName, salesRepId] = rep?.split("|");
        return { fullName, salesRepId } as unknown as InternalUser;
      }) || [];
    setOriginalSalesReps(parsedSalesReps);
    setUsers(parsedSalesReps);
  }, []);

  const isOriginalValues =
    JSON.stringify(users.map((u) => u.salesRepId)) === JSON.stringify(originalSalesReps.map((u) => u.salesRepId));

  return (
    <Stack direction="row" spacing={2} alignItems="center" maxWidth="100%">
      <Box width="100%">
        <InternalUserAutocomplete
          value={users}
          onChange={(value) => {
            // Limit selected option to max 3
            value.length <= limit ? setUsers(value) : null;
          }}
          size="medium"
          label="Select Sales Person"
          multiple
          limitTags={2}
          limitToSalesReps
          getOptionDisabled={(option: InternalUser) => users.length === limit}
        />
      </Box>
      {!isOriginalValues && (
        <Box width="100px">
          <LoadingButton
            fullWidth
            variant="contained"
            size="medium"
            loading={loading}
            onClick={handleSalesRepsChange}
            loadingIndicator="Saving…"
          >
            Save
          </LoadingButton>
        </Box>
      )}
    </Stack>
  );
}
